module.exports = __webpack_public_path__ + "img/4.6a0c4ffa.gif";